import React, { useState, useEffect } from "react";
import {
  FaCheck,
  FaClock,
  FaPlay,
  FaHandHolding,
  FaBookOpen,
  FaStar,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import { Container } from "react-bootstrap";
import author from "../../../assets/images/course/author.jpg";
import course from "../../../assets/images/course/course-detail.png";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";

const CoursesDetailSubject = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [blog, setBlog] = useState();
  const [packagedata, setpackage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const navigate = useNavigate();
  const courseId = localStorage.getItem("courseId");
  const packageId = localStorage.getItem("packageId");
  const sub_Id = localStorage.getItem("sub_Id");

  useEffect(() => {
    fetchBlogDetail();
    fetchPackageDetail();
  }, [courseId]);

  const fetchBlogDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ course_id: courseId }),
        }
      );
      const data = await response.json();
      setBlog(data.data);
      setImagePath(data.imagePath);
      if (data.status === 1) {
        setImagePath(data.imagePath);
      } else {
        console.error("Failed to load blog data");
      }
    } catch (err) {
      console.error("Error fetching blog:", err);
    }
  };
  const fetchPackageDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/course-chaptar-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sub_id: sub_Id }),
        }
      );
      const data = await response.json();
      setpackage(data.data);
      setImagePath(data.imagePath);
      if (data.status === 1) {
        setImagePath(data.imagePath);
      } else {
        console.error("Failed to load blog data");
      }
    } catch (err) {
      console.error("Error fetching blog:", err);
    }
  };

  const stripHTMLTags = (html) => {
    if (!html) return "";
    return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  };
  const handleReadMore = (id) => {
    localStorage.setItem("con_Id", id);
    navigate("/course-detail-content-video");
  };
  return (
    <>
      <section className="course">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
            <img src={breadcrumbImage} alt="Breadcrumbs info" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">Contents Detail</h1>
          </div>
        </div>
        <Container>
          <div className="course_detail subject py-60">
            <div className="container">
              <div className="row">
                {/* Left Side */}
                <div className="col-lg-6">
                  <h2 className="mb-3">{blog?.title || "Unknown Author"}</h2>
                  <p className="mb-4">
                    {stripHTMLTags(blog?.description || "")}
                  </p>
                </div>
              </div>

              <div className="row">
                {/* Tabs Navigation */}
                <h4>Courses to get you started</h4>
                <div className="row">
                  {packagedata &&
                    packagedata.map((item, index) => (
                      <div className="col-lg-3" key={index}>
                        <div className="course__card mb-24">
                          <div className="course__card__content ms-0">
                            <div className="left__block ps-3">
                              <img
                                className="br-20 mb-1"
                                src={
                                  item?.image
                                    ? `${imagePath}${item.image}`
                                    : course
                                }
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = course;
                                }}
                                alt={item?.title || "Course Image"}
                              />
                              <h4 className="mb-4p">
                                <a href="#" className="fs-5">
                                  {item.chapter_name}
                                </a>
                              </h4>
                              <p className="mb-4p fs-6">
                                {" "}
                                {stripHTMLTags(item?.description || "")}
                              </p>
                              <button
                                onClick={() => handleReadMore(item.id)}
                                className="color-primary fs-6 btn-transparent btn"
                              >
                                Chapter Content Video
                                <FaChevronRight />
                              </button>
                              {/* ₹{item.price} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CoursesDetailSubject;
